import Cookies from 'js-cookie'

// MAPpage 的操作提示燈箱只在一次體驗流程中出現一次。
// 使用者按「關閉」後寫入這個旗標，回到首頁時清掉，讓下一位使用者重新看到。
// 兩個頁面共用同一個 key，所以集中在這裡定義，避免字串各寫一份而失去同步。
const MAP_HINT_SEEN_KEY = 'mapHintSeen'

// 不設 expires，寫成 session cookie：關掉瀏覽器就失效。
export function markMapHintSeen() {
  Cookies.set(MAP_HINT_SEEN_KEY, '1')
}

export function hasSeenMapHint() {
  return Cookies.get(MAP_HINT_SEEN_KEY) === '1'
}

export function clearMapHintSeen() {
  Cookies.remove(MAP_HINT_SEEN_KEY)
}
